/* Creme Castle — stale-cart guard (Step 2, Sept 2026).
 *
 * The cart that sits for hours: a slot chosen at 10 AM is still in the cart at
 * 6 PM. This guard re-runs the slot engine for every cake line whenever the
 * cart is shown (drawer open, cart page) and again when "Checkout" is pressed.
 * A line whose date + slot is no longer offerable is marked stale, gets an
 * inline re-pick, and checkout is blocked until it is fixed.
 *
 * Only lines written by the new picker carry properties[_rule]; older lines
 * (Day = "Today") cannot be judged here and are left to the OMS SLOT-CHECK.
 * Fails open: any error in this file lets checkout proceed.
 */
(function () {
  "use strict";
  var E = window.CCSlotEngine, D = window.ccSlotData;
  if (!E || !D || !window.ccClock) return;

  var lastStale = [];   // [{line, props, plan, cityName}]
  var busy = false;

  function cakeLines(cart) {
    var out = [];
    (cart.items || []).forEach(function (it, i) {
      var p = it.properties || {};
      if (p._cake !== "yes" && !(p.city && !p._for)) return;
      if (!p._rule) return; // legacy line, not ours to judge
      out.push({ line: i + 1, item: it, props: p });
    });
    return out;
  }

  function check() {
    return window.ccClock.sync().then(function () {
      return fetch("/cart.js", { cache: "no-store", credentials: "same-origin" }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      var now = window.ccClock.now();
      lastStale = [];
      cakeLines(cart).forEach(function (l) {
        var rule = D.rules[l.props._rule], city = D.cities[l.props.city];
        if (!rule || !city) return;
        var ok = E.isOfferable(rule, city, l.props.Day, l.props.Time, now);
        if (!ok) lastStale.push({ line: l.line, item: l.item, props: l.props, rule: rule, city: city, plan: E.plan(rule, city, now) });
      });
      paint();
      return lastStale;
    }).catch(function (e) { console.warn("[cc-guard] check failed, allowing", e); lastStale = []; return []; });
  }

  /* ---------- UI ---------- */
  var CSS = ".cc-stale{margin:10px 0 4px;padding:12px 14px;border:1.5px solid #DB5436;border-radius:10px;background:#fff6f3;font-family:Montserrat,sans-serif;font-size:13px;color:#3C0618}" +
    ".cc-stale b{display:block;margin-bottom:6px}.cc-stale .cc-days{display:flex;gap:6px;flex-wrap:wrap;margin:6px 0}.cc-stale .cc-day,.cc-stale .cc-pill{border:1px solid #cdcdcd;border-radius:6px;padding:6px 10px;background:#fff;cursor:pointer;font-size:12.5px}" +
    ".cc-stale .cc-day.on,.cc-stale .cc-pill.on{background:#f26d79;color:#fff;border-color:#f26d79}.cc-stale .cc-pills{display:flex;gap:6px;flex-wrap:wrap;margin:6px 0}.cc-stale input[type=date]{margin:4px 0;padding:6px 8px;border:1px solid #cdcdcd;border-radius:6px}" +
    ".cc-stale .cc-save{margin-top:8px;background:#DB5436;color:#fff;border:none;border-radius:8px;padding:9px 14px;font-weight:600;cursor:pointer}.cc-stale .cc-save[disabled]{opacity:.5;cursor:default}.cc-stale .cc-err{color:#b00020;margin-top:6px;font-size:12px}" +
    ".cc-guard-msg{margin:8px 0;padding:10px 12px;border-radius:8px;background:#fff6f3;border:1px solid #DB5436;color:#3C0618;font-size:13px;font-family:Montserrat,sans-serif}";
  function ensureCss() { if (document.getElementById("cc-stale-css")) return; var s = document.createElement("style"); s.id = "cc-stale-css"; s.textContent = CSS; document.head.appendChild(s); }

  // Cart page rows are <div>s; drawer rows are <tr>s, so the box goes in their details cell.
  function lineNodes(line) {
    return Array.prototype.slice.call(document.querySelectorAll("#CartDrawer-Item-" + line + ", #CartItem-" + line)).map(function (n) {
      return n.tagName === "TR" ? (n.querySelector(".cart-item__details") || n) : n;
    });
  }

  function paint() {
    ensureCss();
    document.querySelectorAll(".cc-stale, .cc-guard-msg").forEach(function (n) { n.remove(); });
    lastStale.forEach(function (s) {
      lineNodes(s.line).forEach(function (node) { node.appendChild(buildRepick(s)); });
    });
  }

  function buildRepick(s) {
    var box = document.createElement("div"); box.className = "cc-stale";
    var oldDay = /^\d{4}-\d{2}-\d{2}$/.test(s.props.Day || "") ? E.labelShort(s.props.Day) : (s.props.Day || "");
    var old = oldDay + (s.props.Time ? " · " + s.props.Time : "");
    box.innerHTML = "<b>Your " + esc(s.props.Time || "") + " slot has passed — pick a new time</b>" +
      "<div style='font-size:12px;color:#7E6B6E'>Was: " + esc(old) + " · " + esc(s.props.city || "") + "</div>" +
      "<div class='cc-days'></div><input type='date' style='display:none'><div class='cc-pills'></div>" +
      "<button type='button' class='cc-save' disabled>Update delivery</button><div class='cc-err'></div>";
    var days = box.querySelector(".cc-days"), pillsEl = box.querySelector(".cc-pills"), dateIn = box.querySelector("input[type=date]"), save = box.querySelector(".cc-save"), err = box.querySelector(".cc-err");
    var choice = { ymd: "", slot: "" };
    function pills(ymd, windows) {
      pillsEl.innerHTML = ""; choice = { ymd: ymd, slot: "" }; save.disabled = true;
      if (!windows.length) { pillsEl.innerHTML = "<span style='font-size:12px'>No slots on that day.</span>"; return; }
      windows.forEach(function (w) {
        var p = document.createElement("span"); p.className = "cc-pill"; p.textContent = w;
        p.onclick = function () { pillsEl.querySelectorAll(".cc-pill").forEach(function (x) { x.classList.remove("on"); }); p.classList.add("on"); choice.slot = w; save.disabled = false; };
        pillsEl.appendChild(p);
      });
    }
    function dayBtn(label, ymd) {
      var b = document.createElement("span"); b.className = "cc-day"; b.textContent = label;
      b.onclick = function () {
        days.querySelectorAll(".cc-day").forEach(function (x) { x.classList.remove("on"); }); b.classList.add("on");
        if (ymd) { dateIn.style.display = "none"; pills(ymd, E.windowsFor(s.rule, s.city, ymd, window.ccClock.now())); }
        else { dateIn.style.display = "block"; dateIn.min = s.plan.calendarMin; dateIn.value = ""; pills("", []); }
      };
      days.appendChild(b); return b;
    }
    var first = null;
    s.plan.days.forEach(function (d) { var b = dayBtn(d.label, d.ymd); if (!first && d.windows.length) first = b; });
    dayBtn("Other date", "");
    dateIn.addEventListener("change", function () { if (dateIn.value) pills(dateIn.value, E.windowsFor(s.rule, s.city, dateIn.value, window.ccClock.now())); });
    if (first) first.onclick();
    save.onclick = function () {
      if (!choice.ymd || !choice.slot) return;
      save.disabled = true; save.textContent = "Updating…"; err.textContent = "";
      var props = {}; for (var k in s.props) props[k] = s.props[k];
      props.Day = choice.ymd; props.Time = choice.slot;
      // Keep the readable twin in step with Day, but only on lines that carry it,
      // so a re-pick never adds a new visible property to a legacy line.
      if (Object.prototype.hasOwnProperty.call(props, "Delivery Day")) props["Delivery Day"] = E.labelShort(choice.ymd);
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: s.line, properties: props }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { save.disabled = false; save.textContent = "Update delivery"; err.textContent = "Couldn't update. Please try again."; });
    };
    return box;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- triggers ---------- */
  // Cart page.
  if (/^\/cart\/?$/.test(location.pathname)) document.addEventListener("DOMContentLoaded", function () { check(); });
  // Drawer opening (class "active" is toggled on <cart-drawer>).
  var drawer = document.querySelector("cart-drawer");
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { if (drawer.classList.contains("active")) check(); }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
  // Re-check after Dawn re-renders the cart sections (quantity change, add-on add).
  document.addEventListener("cart:refresh", function () { check(); });

  // Checkout gate: capture-phase click on the Flo buttons, before their inline onclick.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("#checkout2, #checkout2-drawer, [name='checkout2']");
    if (!btn || busy) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    busy = true;
    var label = btn.textContent;
    btn.disabled = true;
    check().then(function (stale) {
      busy = false; btn.disabled = false;
      if (stale.length) {
        var msg = document.createElement("div"); msg.className = "cc-guard-msg";
        msg.textContent = stale.length === 1 ? "One cake's delivery slot has passed. Please pick a new time above before checkout." : stale.length + " cakes have delivery slots that have passed. Please pick new times above before checkout.";
        btn.parentNode.insertBefore(msg, btn);
        var firstBox = document.querySelector(".cc-stale"); if (firstBox) firstBox.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (typeof window.handleFloCheckoutBtn === "function") window.handleFloCheckoutBtn(); else window.location.href = "/checkout";
    });
  }, true);

  window.ccGuard = { check: check };
})();